import "./style.css";
import LangWrapper from "./LangWrapper";
import SubscriptionDetails from "../subscription-details/SubscriptionDetails";
import ProductView from "../product-view/ProductView";
import { BillingCycle } from "../../constants/billing-cycle";
import { CURRENCY_CODES } from "../../constants/currency-codes.c";

const MainWrapper = ({
  isIbec,
  children,
  apiData,
  setApiData,
  setAmountPopup,
  handleApplePayClick,
  slug,
  setDasLoader,
  productList,
  allTrue = false,
  showOnlyHPPForm = false,
  payNowQr = null,
  qrphQr = null,
  onPayNowQrGenerated,
  onPayNowBack,
  onQrphQrGenerated,
  onQrphBack,
}: any) => {
  // console.log(productList, "productList"); 
  return (
    <>
      <div className="wrappers">
        <LangWrapper
          allTrue={allTrue}
          showOnlyHPPForm={showOnlyHPPForm}
          isIbec={isIbec}
          apiData={apiData}
          setApiData={setApiData}
          setAmountPopup={setAmountPopup}
          handleApplePayClick={handleApplePayClick}
          slug={slug}
          setDasLoader={setDasLoader}
          payNowQr={payNowQr}
          qrphQr={qrphQr}
          onPayNowQrGenerated={onPayNowQrGenerated}
          onPayNowBack={onPayNowBack}
          onQrphQrGenerated={onQrphQrGenerated}
          onQrphBack={onQrphBack}
          subscriptionProduct={
            apiData?.subscription && (
              <>
                <SubscriptionDetails
                  amount={apiData?.subscription?.amount}
                  ccy={apiData?.subscription?.ccy}
                  comments={apiData?.subscription?.comments}
                  billingCycleType={apiData?.subscription?.ccy === CURRENCY_CODES.JPY ? BillingCycle[apiData?.subscription?.billingCycleType] :  apiData?.subscription?.billingCycleType}
                  planName={apiData?.subscription?.planName}
                  subscriptionEndsAt={apiData?.subscription?.subscriptionEndsAt}
                  subscriptionSource={apiData?.subscription?.subscriptionSource}
                  subscriptionStartsAt={
                    apiData?.subscription?.subscriptionStartsAt
                  }
                  subscriptionType={apiData?.subscription?.subscriptionType}
                  trialPeriodDuration={
                    apiData?.subscription?.trialPeriodDuration
                  }
                  trialPeriodDurationType={
                    apiData?.subscription?.trialPeriodDurationType
                  }
                  planDiscountPercentage={
                    apiData?.subscription?.planDiscountPercentage
                  }
                  planDiscountDuration={
                    apiData?.subscription?.planDiscountDuration
                  }
                  billingDate={apiData?.subscription?.billingDate}
                  nextBillingDate={apiData?.subscription?.nextBillingDate}
                />
              </>
            )
          }
          pblProduct={
            <>
              <ProductView
                amountLabel={apiData?.amount}
                currency={apiData?.currency}
                productList={productList}
              />
            </>
          }
        >
          <div>
            {/* other payment methods (hiding them for now) */}
            {/* <OtherPaymentMethods /> */}
          </div>
          {children}
        </LangWrapper>
      </div>
    </>
  );
};

export default MainWrapper;
